import { render, staticRenderFns } from "./SendLogs.vue?vue&type=template&id=2be48e9c&scoped=true"
import script from "./SendLogs.vue?vue&type=script&lang=js"
export * from "./SendLogs.vue?vue&type=script&lang=js"
import style0 from "./SendLogs.vue?vue&type=style&index=0&id=2be48e9c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2be48e9c",
  null
  
)

export default component.exports